import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "color-container" }
const _hoisted_2 = { class: "color-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "selected"
}
const _hoisted_4 = {
  key: 0,
  class: "arrows"
}
const _hoisted_5 = { class: "selected-name" }
const _hoisted_6 = { class: "editor" }
const _hoisted_7 = { class: "selected-colors" }
const _hoisted_8 = {
  key: 0,
  class: "empty-message"
}
const _hoisted_9 = { class: "reminder" }
const _hoisted_10 = {
  key: 0,
  class: "btns"
}
const _hoisted_11 = { class: "bnt-next" }
const _hoisted_12 = { class: "bnt-next" }
const _hoisted_13 = {
  key: 0,
  class: "btn filter"
}
const _hoisted_14 = {
  key: 0,
  class: "filter-fill"
}
const _hoisted_15 = {
  key: 1,
  class: "btn"
}
const _hoisted_16 = {
  key: 2,
  class: "btn"
}
const _hoisted_17 = {
  key: 0,
  class: "popover-filter-fill"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_color_card = _resolveComponent("app-color-card")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_palette = _resolveComponent("app-palette")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_popover_item = _resolveComponent("app-popover-item")!
  const _component_app_popover_wrapper = _resolveComponent("app-popover-wrapper")!
  const _component_app_popover = _resolveComponent("app-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.visibleSelectedSection)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.palettesCards.slice(_ctx.startPalette, _ctx.endPalette), (card) => {
              return (_openBlock(), _createBlock(_component_app_color_card, {
                key: card.id,
                index: _ctx.order(card),
                card: card,
                "is-selected": _ctx.selectedCard?.id === card?.id,
                onSelected: _ctx.selected
              }, null, 8, ["index", "card", "is-selected", "onSelected"]))
            }), 128)),
            (_ctx.palettesCards.length > 6)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "arrow left",
                    size: _ctx.isMobile ? 'sm' : '2xl',
                    icon: ['fas', 'arrow-left'],
                    onClick: _ctx.nextPalette
                  }, null, 8, ["size", "onClick"]),
                  _createVNode(_component_font_awesome_icon, {
                    class: "arrow right",
                    size: _ctx.isMobile ? 'sm' : '2xl',
                    icon: ['fas', 'arrow-right'],
                    onClick: _ctx.nextPalette
                  }, null, 8, ["size", "onClick"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t(_ctx.selectedCard.name)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "chevron",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectedSection && _ctx.toggleSelectedSection(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', _ctx.visibleSelectedSection ? 'chevron-down' : 'chevron-up'],
              size: "xl"
            }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_6, [
        _createVNode(_component_app_palette, {
          item: _ctx.selectedCard,
          gap: "8px",
          width: _ctx.isMobile ? '160px' : '200px',
          "selected-mode": true,
          "selected-colors": _ctx.selectedColors,
          onSelectedColor: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedColor($event)))
        }, null, 8, ["item", "width", "selected-colors"]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.selectedColors.size === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "xl",
                    icon: ['fas', 'exclamation-triangle']
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.t('selectTopColors')), 1)
                ])
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.selectedColors, (color) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: color,
                  class: "selected-color",
                  style: _normalizeStyle({ background: color })
                }, null, 4))
              }), 128))
        ]),
        (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_app_button, {
                  raised: "",
                  severity: "secondary",
                  title: "reset",
                  onClick: _ctx.cancelledTemplate
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_app_button, {
                  severity: "success",
                  title: "next",
                  onClick: _ctx.nextStep
                }, null, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", {
        class: _normalizeClass(["buttons", { isMobile: _ctx.isMobile }])
      }, [
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_app_button, {
                raised: "",
                severity: "secondary",
                icon: ['fas', 'filter'],
                title: "filter",
                onClick: _ctx.openPaletteSettings
              }, null, 8, ["onClick"]),
              (!_ctx.isCompareFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_app_button, {
                raised: "",
                icon: ['fas', 'undo'],
                severity: "secondary",
                title: "reset",
                onClick: _ctx.cancelledTemplate
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_app_button, {
                severity: "success",
                title: "next",
                onClick: _ctx.nextStep
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 3,
              icon: ['fas', 'ellipsis-h'],
              size: "xl",
              onClick: _withModifiers(_ctx.openPopover, ["stop"])
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_component_app_popover, {
      visible: _ctx.visiblePopover,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visiblePopover) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, { onClick: _ctx.openPaletteSettings }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'filter']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('filter')), 1),
                (!_ctx.isCompareFilter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}